import { IconHeart, IconWand } from "@tabler/icons-react";
import { memo } from "react";
import { Alert, Button, Card, Form } from "react-bootstrap";

const StepInteractions = memo(
  ({ register, watch, setValue, handleAIFill, MICRO_INTERACTIONS }) => {
    return (
      <div>
        <div className="d-flex align-items-center mb-4">
          <IconHeart className="me-2 text-primary" size={24} />
          <h4 className="mb-0">Micro-Interações Humanizadas</h4>
        </div>

        <Alert variant="info" className="mb-4">
          Configure micro-interações para tornar seu agente mais humanizado e
          natural. Estas configurações aparecerão no final do prompt.
        </Alert>

        {Object.entries(MICRO_INTERACTIONS).map(([key, config]) => (
          <Card key={key} className="mb-3">
            <Card.Body>
              <div className="d-flex align-items-center justify-content-between mb-3">
                <Form.Check
                  type="checkbox"
                  id={`interaction-${key}`}
                  label={<strong>{config.label}</strong>}
                  {...register(`interactions.${key}.enabled`)}
                />
                {watch(`interactions.${key}.enabled`) && (
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() =>
                      handleAIFill(`interactions.${key}.value`, {
                        label: config.label,
                        description: `Configuração para ${config.label.toLowerCase()}`,
                      })
                    }
                  >
                    <IconWand className="me-1" size={14} />
                    Preencher com IA
                  </Button>
                )}
              </div>

              {watch(`interactions.${key}.enabled`) && (
                <Form.Group>
                  <Form.Label>Configuração</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={key === "emojis" ? 8 : 3}
                    {...register(`interactions.${key}.value`)}
                    defaultValue={config.defaultValue}
                    placeholder={config.placeholder}
                  />
                </Form.Group>
              )}
            </Card.Body>
          </Card>
        ))}

        {Object.keys(MICRO_INTERACTIONS).every(
          (key) => !watch(`interactions.${key}.enabled`)
        ) && (
          <div className="text-center py-5 text-muted">
            <IconHeart size={48} className="mb-3" />
            <p>Nenhuma micro-interação habilitada.</p>
            <p>Ative as opções acima para humanizar seu agente.</p>
          </div>
        )}
      </div>
    );
  }
);

StepInteractions.displayName = "StepInteractions";

export default StepInteractions;
